import { render } from "./MobileFloatingBar.vue?vue&type=template&id=037995b3&scoped=true"
import script from "./MobileFloatingBar.vue?vue&type=script&lang=js"
export * from "./MobileFloatingBar.vue?vue&type=script&lang=js"

import "./MobileFloatingBar.vue?vue&type=style&index=0&id=037995b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037995b3"]])

export default __exports__